import './App.css';
import {BrowserRouter as Router,Switch,Route} from "react-router-dom";
import Navbar from './components/navbar';
import Welcome from './components/welcome';
import Games from './components/games';
import Jumprider from './components/jumprider';
import About from './components/about';
import Footer from './components/footer';
function App() {

  return (
    <Router>
      <div className="App">
        <Navbar/>
        <Switch>
          <Route exact path='/' render={props=>(
            <div className="header">
              <Welcome/>
              <Games/>
            </div>
          )}>
          </Route>
          <Route exact path='/jumprider' render={props=>(
            <Jumprider/>
          )}>
          </Route>
          <Route exact path='/About' render={props=>(
            <About/>
          )}>
          </Route>
        </Switch>
        <Footer/>
      </div>
    </Router>
  );
}

export default App;
